var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noticeDetailBox"},[_c('nav-bar',{attrs:{"bg-color":"#446D7A","left-arrow":"","left-color":"#fff","title":_vm.$t('公告详情'),"title-color":"#fff"}}),_c('div',{staticClass:"titleTxt"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"detail",domProps:{"innerHTML":_vm._s(_vm.detail)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }